import React, { useState, useEffect} from 'react';
import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import TabsComponent from '../../components/TabsComponent'
import { useParams } from 'react-router-dom';
import RfidsListing from '../rfidstab/Listing.js'
import WorkOrdersListing from '../../pages/work_orders/Listing'
import BatteriesListing from '../../pages/batteries/Listing'
import DscCoordinatorsListing from '../../pages/dsc_coordinator/Listing'
import TechniciansListing from '../../pages/technicians/Listing'
import PincodesListing from '../../pages/pincodes/Listing.js'
import ServiceCenter from '../../models/ServiceCenter.js';
import VehiclesListing from '../../pages/vehicle/Listing';
import { getApi } from '../../api/endpoints.js';
import DetailsComponent from '../../components/DetailsComponent.js';

const Show = () => {
  const params = useParams();

  const [serviceCenterDetails, setServiceCenterDetails] = useState(new ServiceCenter().toStateJson());
  const [fetchApi] = getApi('showServiceCenter');

  useEffect(() => {
    getRecord({ id: params.id });
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setServiceCenterDetails((new ServiceCenter(response.data.service_center, 2)).toStateJson());
    } catch (error) {
    }
  }
  
  const [tabs] = useState([
    {
      event: 'complaints',
      heading: 'Complaints',
      component: <WorkOrdersListing defaultParams={{service_center_id: params.id}} />,
      ui_action: 'view_service_center_work_orders_tab_list'
    },
    {
      event: 'coordinators',
      heading: 'Coordinators',
      component: <DscCoordinatorsListing defaultParams={{service_center_id: params.id}} />,
      ui_action: 'view_service_center_coordinators_tab_list'
    },
    {
      event: 'technicians',
      heading: 'Technicians',
      component: <TechniciansListing defaultParams={{service_center_id: params.id}} />,
      ui_action: 'view_service_center_technicians_tab_list'
    },
    {
      event: 'voltup_id_cards',
      heading: 'Voltup ID Cards',
      component: <RfidsListing defaultParams={{owner_id: params.id, filters: { owner_type: "ServiceCenter" }}}/>,
      ui_action: 'view_service_center_rfids_tab_list'
    },
    {
      event: 'batteries',
      heading: 'Batteries',
      component: <BatteriesListing defaultParams={{owner_id: params.id, filters: {owner_type: ["ServiceCenter"]}}}/>,
      ui_action: 'view_service_center_batteries_tab_list'
    },
    {
      event: 'vehicles',
      heading: 'Vehicles',
      component: <VehiclesListing defaultParams={{filters: {service_center_ids: [params.id]}}}/>,
      ui_action: 'view_service_center_vehicles_tab_list'
    },
    {
      event: 'pincodes',
      heading: 'Operational PIN Codes',
      component: <PincodesListing defaultParams={{id: params.id}}/>,
      ui_action: 'view_service_center_operational_pincodes_tab_list'
    }
  ])

  return <Page
    uiPage={uiManager.getUiPage(PAGES.ShowServiceCenterPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Service Center", url: "/service_centers" }, { label: "Details" }]}
    className={'view-service-center-page'}
  >
    <PageContentWrapper contentHeading={"Service Center Details"}>
    <DetailsComponent data={serviceCenterDetails} />
      <div className="mt-3">
      <TabsComponent defaultActiveEvent={'complaints'} data={tabs} />
      </div>
    </PageContentWrapper>
  </Page>
};

export default Show;

